import _ from 'lodash';
import { createClient } from '@/shared/api';
import type {
  ClinicStudiesCompletedQuery,
  ClinicStudiesCompletedQueryVariables,
} from '@/shared/api';
import CLINIC_STUDIES_COMPLETED_QUERY from '../queries/clinicStudiesCompleted';

/**
 * Loads a filtered page of completed clinic studies. Runs CLINIC_STUDIES_COMPLETED_QUERY and throws the first GraphQL error message when clinicStudies is nil.
 *
 * @param filter - Filter criteria forwarded to the GraphQL query.
 * @param limit - Maximum number of records to return, defaulting to 10.
 * @returns The completed clinic studies page.
 */
const fetchCompletedClinicStudies = async (
  filter: ClinicStudiesCompletedQueryVariables['filter'],
  limit = 10,
): Promise<ClinicStudiesCompletedQuery['clinicStudies']> => {
  const client = createClient();
  const clinicStudiesResult = await client.query<
    ClinicStudiesCompletedQuery,
    ClinicStudiesCompletedQueryVariables
  >({
    query: CLINIC_STUDIES_COMPLETED_QUERY,
    variables: {
      filter,
      limit,
    },
  });
  const { data, errors } = clinicStudiesResult;
  const { clinicStudies } = data;
  if (_.isNil(clinicStudies) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return clinicStudies;
};

export default fetchCompletedClinicStudies;
